import React, { useEffect } from 'react'

import { BonusModal, BonusModalProps } from '@/modals/BonusModal'
import { FeatureFlagsModal, FeatureFlagsModalProps } from '@/modals/FeatureFlagsModal'
import { LoginModal, LoginModalProps } from '@/modals/LoginModal'
import { OfferExpiredModal, OfferExpiredModalProps } from '@/modals/OfferExpiredModal'
import { ProductModal, ProductModalProps } from '@/modals/ProductModal'
import { UnavailableModal, UnavailableModalProps } from '@/modals/UnavailableModal'
import { useAppSelector } from '@/utils/useAppSelector'
import { useBreakpoints } from '@/utils/useBreakpoints'

import {
  OnboardingLoginModal,
  OnboardingLoginModalProps,
} from '../storefronts/landing/Onboarding/components/OnboardingLoginModal'
import { OnboardingModal, OnboardingModalProps } from '../storefronts/landing/Onboarding/components/OnboardingModal'

export type OverlayProps = {
  overlay:
    | BonusModalProps
    | FeatureFlagsModalProps
    | LoginModalProps
    | OfferExpiredModalProps
    | ProductModalProps
    | UnavailableModalProps
    | OnboardingModalProps
    | OnboardingLoginModalProps
    | null
}

export function Overlay({ overlay }: OverlayProps) {
  const gameStoresEnabled = useAppSelector((state) => state.config.storefront)
  const from = useBreakpoints().from
  const isDesktop = from('tablet')

  /* Hide body scroll when modal is open */
  useEffect(() => {
    if (overlay && gameStoresEnabled) {
      if (overlay !== null) {
        document.body.style.overflow = 'hidden'

        // add padding to body to prevent content from shifting when scroll is hidden
        overlay.type === 'PRODUCT' && isDesktop ? (document.body.style.paddingRight = '15px') : null
      }

      return () => {
        document.body.style.overflow = 'auto'
        document.body.style.paddingRight = '0'
      }
    }
  }, [overlay, gameStoresEnabled, isDesktop])

  if (!overlay) {
    return null
  }

  switch (overlay.type) {
    case 'BONUS_INFO':
      return <BonusModal />
    case 'FEATURE_FLAGS':
      return <FeatureFlagsModal />
    case 'LOGIN':
      return <LoginModal {...overlay.props} />
    case 'OFFER_EXPIRED':
      return <OfferExpiredModal {...overlay.props} />
    case 'PRODUCT':
      return <ProductModal {...overlay.props} />
    case 'UNAVAILABLE':
      return <UnavailableModal />
    case 'ONBOARDING':
      return <OnboardingModal {...overlay.props} />
    case 'ONBOARDING_LOGIN':
      return <OnboardingLoginModal {...overlay.props} />
    default:
      return null
  }
}
